
import { defineComponent } from "vue";

export default defineComponent({
  name: "CustomerCompanyInfo",
  props: {
    data: {
      type: Object,
    },
    title: {
      type: String,
      default: "",
    },
  },
});
